import React, { useEffect } from 'react';

import ContentHeader from '../../components/ContentHeader';
import Footer from '../../components/Footer';
import MainHeader from '../../components/MainHeader';
import SideMenu from '../../components/SideMenu';

import imgCourses from '../../assets/images/img-cursos.jpg';

import { useSession } from '../../providers/SessionProvider';

function Courses() {
  const { setIsAssessoryMenuSelected } = useSession();

  useEffect(() => {
    setIsAssessoryMenuSelected(false);
  }, []);

  return (
    <div className="interna gray">
      <div className="white" />
      <div className="container bug-height">
        <div className="row first-row">
          <div className="col grid_3 left-menu">
            <MainHeader />
            <SideMenu />
          </div>
          <div className="col grid_9 content">
            <ContentHeader />
            <h3>Cursos online:</h3>
            <div className="cursos">
              <ul>
                <li className="row gutters">
                  <div className="col grid_5 image">
                    <img
                      src={imgCourses}
                      width="422"
                      height="291"
                      alt="Curso OnLine"
                    />
                    <div className="blue" />
                  </div>
                  <div className="col grid_7 text">
                    <h4>Princípios de como ser um bom Agente</h4>
                    <p>
                      É simplesmente uma simulação de texto da indústria
                      tipográfica e de impressos, e vem sendo utilizado desde o
                      século XVI, quando um impressor desconhecido pegou uma
                      bandeja de tipos e os embaralhou para fazer um livro de
                      modelos de tipos.
                    </p>
                    <p>
                      <a href="/">Acessar</a>
                    </p>
                  </div>
                </li>
                <li className="row gutters">
                  <div className="col grid_5 image">
                    <img
                      src={imgCourses}
                      width="422"
                      height="291"
                      alt="Curso OnLine"
                    />
                    <div className="blue play" />
                  </div>
                  <div className="col grid_7 text">
                    <h4>Princípios de como ser um bom Agente</h4>
                    <p>
                      É simplesmente uma simulação de texto da indústria
                      tipográfica e de impressos, e vem sendo utilizado desde o
                      século XVI, quando um impressor desconhecido pegou uma
                      bandeja de tipos e os embaralhou para fazer um livro de
                      modelos de tipos.
                    </p>
                    <p>
                      <a href="/">Acessar</a>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Courses;
